import { CardMedia, CardHeader, CardContent, Text } from '@pega/cosmos-react-core';
import React from 'react';
import { addConnectionProps } from '../../../interfaces/common';
import { StyledCard } from '../../Utilities/custom.styled';

interface AddConnectionCardProps {
  onClick: () => void;
  children: addConnectionProps;
}
const AddConnectionCard: React.FC<AddConnectionCardProps> = (props) => {
  const {
    children: { image, title, description, width, height },
    onClick,
  } = props;

  return (
    <StyledCard
      onClick={onClick}
      className="pointer"
      style={{ alignItems: 'center', padding: '2rem 0 .5rem 0', borderRadius: 0 }}
      interactive={true}
    >
      <CardMedia style={{ width: width || '101px', height: height || '101px' }}>{image}</CardMedia>
      <CardHeader style={{ padding: '.5rem 0' }}>
        <Text variant="h3" style={{ textAlign: 'center' }}>
          {title}
        </Text>
      </CardHeader>
      <CardContent style={{ textAlign: 'center' }}>
        <Text variant="secondary">{description}</Text>
      </CardContent>
    </StyledCard>
  );
};

export default AddConnectionCard;
